<template>
  <Content @back = "back" :noBack="['expert','organ'].includes(userRole)">
    <template v-slot:nav_left>
      <div class="nav_wrap">
        <div class="nav_list">
          <div class="nav_item active">人才输送</div>
          <div class="nav_item" @click="jumpTo('/record/list')">参赛成绩(高水平赛事)</div>
          <div class="nav_item" @click="jumpTo('/record/list?idx=1')">集训营</div>
        </div>
      </div>
    </template>
    <template v-slot:nav_right>
      <div v-if="['youth','club'].includes(userRole)" class="yioks_btn" @click="openAddDialog">添加人才输送成果</div>
    </template>
    <template v-slot:content_right>
      <div class="select_wrap">
        <!--<div class="count" v-if="userRole === 'system' || userRole === 'admin'">-->
          <!--<span>输送至各级国家队：{{guo}}人</span>-->
          <!--<span style="margin-left:40px;">输送至全运队：{{quan}}人</span>-->
          <!--<span style="margin-left:40px;">输送至职业俱乐部：{{club}}人</span>-->
        <!--</div>-->
        <div class="remember">
          <el-button type="primary" size="mini" @click="playerExport" :disabled="isShowLoading" :loading="addbtnLoading">导出人才输送汇总表</el-button>
        </div>
        <div class="select_box" >
          <select
            v-model="selectVal.organUuid"
            class="yioks_select"
            @change="changeOrg"
            v-if="userRole === 'system' || userRole === 'admin'"
            style="width:130px"
          >
            <option v-if="organList.length > 1" value="">全部会员协会</option>
            <option
              v-for="item in organList"
              :key="item.organUuid"
              :value="item.organUuid"
            >
              {{ item.organShortName }}
            </option>
          </select>
          <select
            v-model="selectVal.youthUuid"
            class="yioks_select"
            @change="changeCenter"
            v-if="userRole === 'system' || userRole === 'admin'"
            style="width:130px"
          >
            <option v-if="centerList.length !== 1" value="">
              全部培训机构
            </option>
            <option
              v-for="item in centerList"
              :key="item.uuid"
              :value="item.uuid"
            >
              {{ item.youthShortName }}
            </option>
          </select>
          <select
            v-model="selectVal.activityTypeEnum"
            class="yioks_select"
            @change="changeQuery(true)"
            style="width:105px"
          >
            <option value="">
              全部类型
            </option>
            <option
              v-for="item in activityTypeEnumList"
              :key="item.value"
              :value="item.value"
            >
              {{ item.label }}
            </option>
          </select>
          <select
            v-model="selectVal.talentSendStatus"
            class="yioks_select"
            @change="changeQuery(true)"
            style="width:105px"
          >
            <option value="">
              审核状态
            </option>
            <option
              v-for="item in auditStateListExtend"
              :key="item.value"
              :value="item.value"
            >
              {{ item.label }}
            </option>
          </select>
        </div>
        <div class="search_box">
          <input
            v-model.trim="selectVal.keyWord"
            type="text"
            class="yioks_input"
            placeholder="请输入球员姓名或者身份证号搜索"
            @keyup.enter="changeQuery(true)"
            style="width:200px"
          >
          <div class="yioks_btn" @click="changeQuery(true)">搜索</div>
        </div>
      </div>
      <div class="list_wrap">
        <div v-if="showList" class="table">
          <div class="thead">
            <div class="tr">
              <div class="th seq"><strong>序号</strong></div>
              <div class="th name"><strong>申报精英机构</strong></div>
              <div class="th org"><strong>球员姓名</strong></div>
              <div class="th telNumber"><strong>出生日期</strong></div>
              <div class="th squad"><strong>注册时长</strong></div>
              <!--<div class="th score"><strong>分数</strong></div>-->
              <div class="th status"><strong>审核状态</strong></div>
              <div class="th opt"><strong>操作</strong></div>
            </div>
          </div>
          <div class="scrollArea">
            <vue-scroll >
              <div class="tbodyWrap">
                <div class="tbody">
                  <div
                    v-for="(item, index) in playerTalentSendList"
                    :key="index"
                    class="tr">
                    <div class="td seq">
                      <p>{{ index + 1 }}</p>
                    </div>
                    <div class="td name" :title="item.youthShortName">
                      <p>{{ item.youthShortName || '--' }}</p>
                    </div>
                    <div class="td org" :title="item.playerName">
                      <p>{{item.playerName || '--'}}</p>
                    </div>
                    <div class="td telNumber" :title="item.idNumber">
                      <p>{{ item.birthday | formatDateStamp }}</p>
                    </div>
                    <div class="td squad">
                      <p>{{ item.trainTimes ? item.trainTimes + '个月' :  '--' }}</p>
                    </div>
                    <!--<div class="td score">-->
                      <!--<p>{{ item.maxScore}}</p>-->
                    <!--</div>-->
                    <div class="td status">
                      <p>{{ item.talentSendStatus | auditState }}</p>
                    </div>
                    <div class="td opt" v-if="['youth','club'].includes(userRole)">
                      <p>
                        <span class="item" @click="goInfo(item.uuid)">查看</span>
                        <span class="item" @click="goEdit(item.uuid)"  style="margin-left:5px"  >编辑</span>
                        <span class="item" @click="toDeleteItem(item)"  style="margin-left:5px"  >删除</span>
                      </p>

                    </div>
                    <div class="td opt" v-else >
                      <p>
                        <span class="item" @click="goInfo(item.uuid)">查看</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </vue-scroll>
          </div>
        </div>
        <yioks-loading v-if="loading" />
        <yioks-empty v-if="empty" />
      </div>
      <Pagination :total="total" :pageSize="pageSize" :page.sync="page"/>
      <yioks-tip
        :showTip="isShowDeleteTips"
        tipMsg="确定删除该数据吗？"
        @callback="deleteBack"
      />
      <el-dialog
        :visible.sync="batchAdd"
        width="510px"
        title="请输入要申报的球员"
        :close-on-click-modal="false"
        :destroy-on-close="true"
        custom-class="yioks_alert2"
      >
        <el-form ref="batchInfo" :rules="formRules" :model="batchInfo" label-width="120px">
          <div style="margin-bottom:10px;">
            <span style="color:#f88594">
              注：申报机构应于2022-2025年期间向国家队、本市全运队等上级训练单位输送优秀球员，所输送球员应自2015年1月1日起曾在市足协注册于申报机构。输送球员以最高得分项计分，不重复计入。
            </span>
          </div>
          <vue-scroll ref="scroll" :ops="ops">
            <div style="margin-right: 30px">
              <el-form-item label="是否本机构球员"  class="yioks-switch-grey">
                <el-switch
                  v-model="isStuExit"
                  active-text="是"
                  inactive-text="否"
                  active-color="#4cd964"
                  @change="changeSwitch"
                ></el-switch>
              </el-form-item>
              <template v-if="isStuExit">
                <el-form-item
                  label="管理协会"
                  required
                  prop="organUuid"
                  :rules="[{ required: true, message: '必填项' }]"
                >
                  <el-select
                    v-model.trim="batchInfo.organUuid"
                    style="width: 100%"
                    placeholder="请选择管理协会"
                    @change="changeBathOrg"
                  >
                    <el-option
                      v-for="(item, index) in batchOrganList"
                      :key="index"
                      :value="item.organUuid"
                      :label="item.organShortName"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item
                  label="单位"
                  required
                  prop="youthUuid"
                  :rules="[{ required: true, message: '必填项' }]"
                >
                  <el-select
                    v-model.trim="batchInfo.youthUuid"
                    style="width: 100%"
                    placeholder="请选择管理协会后再选择单位"
                    @change="changeBathCenter"
                  >
                    <el-option
                      v-for="item in batchCenterList"
                      :key="item.uuid"
                      :value="item.uuid"
                      :label="item.youthShortName"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item
                  label="选择球队"
                  required

                >
                  <el-select
                    v-model.trim="batchInfo.squadUuid"
                    style="width: 100%"
                    placeholder="请选择球队"
                    no-data-text="暂时没有球队，请前往球队管理添加球队"
                    @change="changeTeam"
                  >
                    <el-option
                      v-for="item in batchSquadList"
                      :key="item.uuid"
                      :value="item.uuid"
                      :label="item.shortName"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item
                  label="选择球员"
                  required
                  prop="playerUuid"
                  :rules="[{ required: true, message: '必填项' }]"
                >
                  <el-select
                    v-model.trim="batchInfo.playerUuid"
                    style="width: 100%"
                    placeholder="请先选择球队后再选择球员"
                    no-data-text="暂时没有球员，请前往球员管理添加球员"
                    filterable
                    @change="playerChange"
                  >
                    <el-option
                      v-for="(item, index) in playerList"
                      :key="index"
                      :value="item.uuid"
                      :label="item.uname"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </template>
              <template v-else>
                <el-form-item label="球员姓名" prop="player_name"
                  :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
                  <el-input v-model="batchInfo.player_name" placeholder="请输入球员姓名"></el-input>
                </el-form-item>
                <el-form-item label="证件号" prop="player_id_number">
                  <el-input v-model="batchInfo.player_id_number" :placeholder="id_numberMsg"></el-input>
                </el-form-item>
                <el-form-item label="证件类型" prop="idType">
                  <el-select
                    v-model="batchInfo.idType"
                    placeholder="请选择证件类型"
                    style="width: 100%"
                    @change="changeType(batchInfo.idType)"
                  >
                    <el-option
                      v-for="(item, index) in id_types"
                      :key="index"
                      :label="item.key"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </template>
            </div>
          </vue-scroll>
        </el-form>
        <div class="btn-wrapper" style="display:flex;justify-content:center">
          <el-button type="primary" @click="toAddSupervision">添加人才输送成果</el-button>
        </div>
      </el-dialog>
    </template>
  </Content>
</template>

<script>

  import 'vue-awesome/icons/regular/edit'
  import playerTalentSend from '@/api/playerTalentSend'
  import player from "@/api/player";
  import squad from '@/api/squad'
  import storage from '@/utils/storage'
  import { centerStatus } from '@/utils/yioks_filter'
  import mixinAddressForSH from '@/mixin/mixinAddressForSH';
  import mixinAppConfig from "@/mixin/mixinAppConfig";
  import {ops} from "@/utils/scrollIndialog";
  import {  id_types } from "@/utils/yioks_data";
  import regions from '@/utils/regions'
  import rules from "@/utils/formRules/rules";
  import {activityTypeEnumList,auditStateListExtend} from "@/assets/js/yioksSelect";
  import common from "@/api/common";
  import { downloadByJs } from "@/utils/commen";
  export default {
    mixins: [mixinAddressForSH,mixinAppConfig],
    components: {
      'Content': () => import('@/components/layout/list'),
      'Pagination': () => import('@/components/Pagination'),
      'AddPlayerDialog': () => import('@/components/center'),
    },
    filters: {
      auditState(val) {
        let res = '';
        switch (val) {
          case 'audit':
            res = '待审核';
            break;
          case 'pass':
            res = '通过';
            break;
          case 'refused':
            res = '驳回';
            break;
          default:
            res = '--';
            break;
        }
        return res;
      },
    },
    data () {
      return {
        ops,
        id_types,
        isStuExit: true,
        selectRegions: regions,
        total: 0,
        page: 0,
        pageSize: 20,
        empty: false,
        showList: false,
        loading: true,
        isShowDeleteTips: false,
        deleteUuid: '',
        batchAdd: false,
        isShowLoading: false,
        addbtnLoading: false,
        guo:'',
        quan:'',
        club:'',
        selectVal: {
          keyWord: '',
          activityTypeEnum: '',
          youthUuid: "",
          talentSendStatus: '',
          organUuid: ''
        },
        organList: [], // 机构列表
        playerList: [], //球员列表
        centerList: [], // 青训中心列表,
        playerTalentSendList: [], // 列表,
        squadList: [],
        selectsquadList: [],
        batchOrganList: [], // 管理协会列表
        batchCenterList: [], // 单位列表
        batchSquadList: [], //  球队列表
        activityTypeEnumList:activityTypeEnumList,
        auditStateListExtend:auditStateListExtend,
        userRole:storage.get('userInfo').userRole,
        id_numberMsg: '请输入身份证号',
        batchInfo: {
          idType: "IDNUMBER",
          player_name: "",
          player_id_number: "",
          squadUuid: "", // 球队
          playerUuid: "", // 球队
        }, // 弹窗表单
        formRules:{
          player_id_number:[
            {
              validator:(rule, val, callback) => {
                if(val){
                  if(this.batchInfo.idType === "IDNUMBER"){
                    if(rules.idNumber(val)){
                      callback();
                    }else{
                      callback(new Error("请输入有效的证件号"));
                    }
                  }else if(this.batchInfo.idType === "PASSPORT"){
                    if(rules.checkPassport(val)){
                      callback();
                    }else{
                      callback(new Error("请输入有效的护照号码"));
                    }
                  }else if(this.batchInfo.idType === "IDTYPECODEWGJZZ"){
                    if(rules.checkWork(val)){
                      callback();
                    }else{
                      callback(new Error("请输入有效的外国人居留证号码"));
                    }
                  }else if(this.batchInfo.idType === "HM"){
                    if(rules.checkHkongMacao(val)){
                      callback();
                    }else{
                      callback(
                        new Error("请输入9位有效的港澳居民来往内地通行证号码")
                      );
                    }
                  }else if(this.batchInfo.idType === "TAI"){
                    if(rules.checkTaiwOld(val)){
                      callback();
                    }else{
                      callback(
                        new Error("请输入8位有效的台湾居民来往大陆通行证号码")
                      );
                    }
                  }else if(this.batchInfo.idType === "IDTYPECODEHMT"){
                    if(/^8[1-3]\d{16}/.test(val) && rules.idNumber(val)){
                      // 避免验证所有表单时，重复请求
                      callback();
                    }else{
                      callback(new Error("请输入18位有效的港澳台居民居住证号码"));
                    }
                  }
                }else{
                  callback(new Error("请输入证件号"));
                }
              },
              required:true,
              trigger:"blur",
            },
          ],
        },
      }
    },
    watch: {
      page () {
        this.changeQuery()
      },
    },
    created () {
      const { page,  youthUuid, organUuid, keyWord,activityTypeEnum,talentSendStatus } = this.$route.query
      page && (this.page = Number(page))
      youthUuid && (this.$set(this.selectVal, 'youthUuid', youthUuid))
      organUuid && (this.$set(this.selectVal, 'organUuid', organUuid))
      keyWord && (this.$set(this.selectVal, 'keyWord', keyWord))
      activityTypeEnum && (this.$set(this.selectVal, 'activityTypeEnum', activityTypeEnum))
      talentSendStatus && (this.$set(this.selectVal, 'talentSendStatus', talentSendStatus))
      // this.getCoachAccount()
      this.getOrganListAndCenterList();

      //     this.getCenterList()
      this.changeQuery();
      if(this.userRole === 'system' || this.userRole === 'admin'){
        this.getCount();
      }
    },
    methods: {
      back(){
        if ( this.userRole === "expert" || this.userRole === "organ"){
          this.$router.go(-1)
        }else if ( this.userRole === "admin"){
          this.$router.push('/home/index?details=mans')
        }else {
          this.$router.push('/home')
        }
      },
      playerExport(){
        this.isShowLoading = true;
        this.addbtnLoading = true;
        playerTalentSend.getTalentSendExport().then((res) => {
          this.addbtnLoading = false;
          this.isShowLoading = false;
          if(res.code){
            this.$message.error(res.msg);
            return
          }
          const { fileName, filePath } = res;
          const transferPath = this.$yioksConfig.transferBaseOnly(filePath)
          downloadByJs(transferPath, fileName);
        })
        .catch((err) => {
          this.isShowLoading = false;
          console.error("异常", err);
        });
      },
      getCount(){

        playerTalentSend.getTalentSendCount().then((res) => {
          if(res.code){
            this.$message.error(res.msg);
            return
          }
          const { guo, quan,club } = res;
          this.guo = guo;
          this.quan = quan;
          this.club = club;
        })
        .catch((err) => {

          console.error("异常", err);
        });
      },
      changeSwitch(){
        this.$set(this.batchInfo, "player_name", "");
        this.$set(this.batchInfo, "player_id_number", "");
        this.$set(this.batchInfo, "idType", "IDNUMBER");
        this.$set(this.batchInfo, "playerUuid", "");
        this.$refs['batchInfo'].clearValidate();
      },


      changeType(val) {
        switch (this.batchInfo.idType) {
          case "IDNUMBER": // 身份证
            this.id_numberMsg = "请输入身份证号";
            break;
          case "IDTYPECODEWGJZZ": // 外国人永久居留身份证
            this.id_numberMsg = "例如：CAN000000000000";
            break;
          case "IDTYPECODEHMT": // 港澳台居民居住证
            this.id_numberMsg = "请输入港澳台居民居住证号";
            break;
          case "HM": // 港澳居民来往内地通行证
            this.id_numberMsg = "例如：H00000000";
            break;
          case "TAI": // 台湾居民来往大陆通行证
            this.id_numberMsg = "例如：00000000";
            break;
          case "PASSPORT": // 护照（非中国大陆人员）
            this.id_numberMsg = "例如：E00000000";
            break;
        }
      },
      jumpTo(path) {
        if(this.userRole === 'expert' || this.userRole === 'organ'){
          this.$router.replace({
            path: path,
            query: {
              organUuid: this.selectVal.organUuid,
              youthUuid: this.selectVal.youthUuid,
            }
          })
        }else{
          this.$router.push(path)
        }
      },
      openAddDialog() {
        this.batchAdd = true;
      },
      /* 机构选择 */
      changeBathOrg(val) {
        this.batchSquadList = [];
        this.batchCenterList = [];
        this.$set(this.batchInfo, "youthUuid", "");
        this.$set(this.batchInfo, "organShortName", "");
        this.$set(this.batchInfo, "youthShortName", "");
        this.$set(this.batchInfo, "squadUuid", "");
        if (this.batchInfo.organUuid) {
          this.batchInfo.organShortName = this.batchOrganList.find((item) => {
            return item.organUuid === this.batchInfo.organUuid;
          }).organShortName;
          this.batchCenterList =
            this.batchOrganList.find((item) => {
              return item.organUuid === this.batchInfo.organUuid;
            }).youthList || [];
          if (this.batchCenterList.length === 1) {
            // this.$set(this.selectVal, 'youthUuid', this.centerList[0].uuid)
            this.$set(this.batchInfo, "youthUuid", this.batchCenterList[0].uuid);
            this.$set(
              this.batchInfo,
              "youthShortName",
              this.batchCenterList[0].youthShortName
            );
            this.batchSquadList =
              this.batchCenterList.find((item) => {
                return item.uuid === this.batchInfo.youthUuid;
              }).squadList || [];
            if (this.batchSquadList.length === 1) {
              this.$set(this.batchInfo, "squadUuid", this.batchSquadList[0].uuid);
            }
          }
        }
      },

      /* 单位变化 */
      changeBathCenter(val) {
        this.batchInfo.squadUuid = "";
        this.batchSquadList = [];
        this.batchInfo.youthShortName = "";
        if (this.batchInfo.youthUuid) {
          this.batchInfo.youthShortName =
            this.batchCenterList.find((item) => {
              return item.uuid === this.batchInfo.youthUuid;
            }).youthShortName || "";
          this.batchSquadList =
            this.batchCenterList.find((item) => {
              return item.uuid === this.batchInfo.youthUuid;
            }).squadList || [];
          // if (this.batchSquadList.length === 1) {
          //   this.$set(this.batchInfo, "squadUuid", this.batchSquadList[0].uuid);
          // }
        }
      },
      // 获取协会列表
      getOrganListAndCenterList() {
        let data = this.uuid;
        let request;
        if (this.userRole === "organ") {
          request = squad.getOrgListByOrgan;
        } else if (this.userRole === "system" || this.userRole === "admin" || this.userRole === "expert") {
          request = squad.getOrgListBySystem;
          data = "";
        } else if (
          this.userRole === "youth" ||
          this.userRole === "trainCamp" ||
          this.userRole === "club"
        ) {
          request = squad.getOrgListByYouth;
        } else if (this.userRole === "leader" || this.userRole === "coach") {
          // request = squad.getOrgListByCoachOrLeader;
          // console.log('在created方法中，短路此方法')
        }
        request(data).then((res) => {
          this.batchOrganList = res;
          this.organList = res;
          if (this.selectVal.organUuid) {
            if (this.selectVal.youthUuid) {
              this.centerList =
                this.organList.find((item) => {
                  return item.organUuid === this.selectVal.organUuid;
                }).youthList || [];
              if (this.selectVal.squadUuid) {
                this.squadList =
                  this.centerList.find((item) => {
                    return item.uuid === this.selectVal.youthUuid;
                  }).squadList || [];
              }
            }
          } else {
            if (this.organList.length === 1) {
              this.$set(this.selectVal, "organUuid", this.organList[0].organUuid);
              this.$set(
                this.batchInfo,
                "organUuid",
                this.batchOrganList[0].organUuid
              );
              this.$set(
                this.batchInfo,
                "organShortName",
                this.batchOrganList[0].organShortName
              );
              this.centerList =
                this.batchOrganList.find((item) => {
                  return item.organUuid === this.selectVal.organUuid;
                }).youthList || [];
              this.batchCenterList = this.centerList;
              if (this.centerList.length === 1) {
                this.$set(this.selectVal, "youthUuid", this.centerList[0].uuid);
                this.$set(
                  this.batchInfo,
                  "youthUuid",
                  this.batchCenterList[0].uuid
                );
                this.$set(
                  this.batchInfo,
                  "youthShortName",
                  this.batchCenterList[0].youthShortName
                );
                this.squadList =
                  this.centerList.find((item) => {
                    return item.uuid === this.selectVal.youthUuid;
                  }).squadList || [];
                this.batchSquadList = this.squadList;
                if (this.squadList.length === 1) {
                  this.$set(this.selectVal, "squadUuid", this.squadList[0].uuid);
                  this.$set(this.batchInfo, "squadUuid", this.squadList[0].uuid);
                  this.changeTeam(this.squadList[0].uuid);
                }
              }
            }
          }
        });
      },
      /* 球队变化 */
      changeTeam(val) {
        if (val) {
          player
          .getSquadPlayer(val)
          .then((res) => {
            this.playerList = res.map((item) => ({
              uuid: item.uuid,
              uname: item.idName,
              idNumber: item.idNumber,
            }));
          })
          .catch((err) => {
            console.error(err);
          });
        }
      },
      /* 球员变化 */
      playerChange(val) {
        this.playerList.find((ite) => {
          if(ite.uuid === val){
            this.batchInfo.player_name = ite.uname;
            this.batchInfo.player_id_number = ite.idNumber;
            this.batchInfo.idType = "";
          }
        })
      },

      getCenterList () {
        this.loading = true
        this.empty = false
        this.showList = false
        let req = playerTalentSend.getPlayerTalentSendListYouth
        if (this.userRole === 'system' || this.userRole === 'admin' || this.userRole === 'expert') { req = playerTalentSend.getPlayerTalentSendListSystem } else if (this.userRole === 'organ') {req = playerTalentSend.getPlayerTalentSendListOrgan}
        req({ page: this.page, size: this.pageSize, seacherString: this.selectVal.keyWord, activityTypeEnum: this.selectVal.activityTypeEnum, talentSendStatus: this.selectVal.talentSendStatus,  youthUuid: this.selectVal.youthUuid, organUuid: this.selectVal.organUuid, }).then((res) => {
          this.loading = false
          let data = res.content
          this.total = res.totalElements
          if (data.length) {
            this.playerTalentSendList = data
            this.showList = true
          } else {
            this.empty = true
          }
        }).catch((err) => {
          this.loading = false
          console.error(err)
        })
      },

      goInfo (uuid) {
        this.$router.push({
          path: 'viewTalentSendPlayer',
          query: {
            talent_send_uuid:uuid
          }
        })
      },
      goEdit (uuid) {
        this.$router.push({
          path: 'editTalentSendPlayer',
          query: {
            talent_send_uuid:uuid
          }
        })
      },

      changeOrg(val) {
        this.centerList = [];
        this.squadList = [];
        this.$set(this.selectVal, "youthUuid", "");
        this.$set(this.selectVal, "squadUuid", "");
        if (this.selectVal.organUuid) {
          const { youthList } = this.organList.find((item) => {
            return item.organUuid === this.selectVal.organUuid;
          });
          this.centerList = youthList || [];
          if (this.centerList.length === 1) {
            this.$set(this.selectVal, "youthUuid", this.centerList[0].uuid);
            this.squadList =
              this.centerList.find((item) => {
                return item.uuid === this.selectVal.youthUuid;
              }).squadList || [];
            if (this.squadList.length === 1) {
              this.$set(this.selectVal, "squadUuid", this.squadList[0].uuid);
            }
          }
        }
        this.changeQuery(true);
      },

      changeCenter(val) {
        this.squadList = [];
        this.$set(this.selectVal, "squadUuid", "");
        if (this.selectVal.youthUuid) {
          this.squadList =
            this.centerList.find((item) => {
              return item.uuid === this.selectVal.youthUuid;
            }).squadList || [];
          if (this.squadList.length === 1) {
            this.$set(this.selectVal, "squadUuid", this.squadList[0].uuid);
          }
        }
        this.changeQuery(true);
      },


      changeQuery (flag) {
        if (flag) this.page = 0
        this.$router.replace({
          path: this.$route.path,
          query: {
            page: this.page,
            squadUuid: this.selectVal.squadUuid,
            youthUuid: this.selectVal.youthUuid,
            keyWord: this.selectVal.keyWord,
            activityTypeEnum: this.selectVal.activityTypeEnum,
            talentSendStatus: this.selectVal.talentSendStatus,
            organUuid: this.selectVal.organUuid
          }
        })
        this.getCenterList()
      },

      // 添加督导训练
      toAddSupervision() {
        let queryData = {};
        this.batchInfo.player_id_number = this.batchInfo.player_id_number.trim().toUpperCase();
        this.batchInfo.player_name = this.batchInfo.player_name.trim();
        let { player_name, player_id_number, idType,playerUuid } = this.batchInfo;
        queryData = {
          player_name, player_id_number, idType,playerUuid
        }
        this.$refs.batchInfo.validate((valid) => {
          if(valid) {
            playerTalentSend
            .talentSendPlayerVerify(this.batchInfo.player_id_number,this.batchInfo.player_name)
            .then((res) => {
              if (res.code) {
                this.$message.error(res.msg);
              } else {
                this.$router.push({
                  path: "addTalentSendPlayer",
                  query: queryData,
                });
              }
            })
            .catch((err) => {
              console.error(err);
            });
          } else {
            //          this.$message.warning("请先选择球员");
          }
        })
      },
      /* 删除 */
      toDeleteItem(row) {
        const { uuid } = row;
        this.deleteUuid = uuid;
        this.isShowDeleteTips = true;
      },

      deleteBack(sure) {
        if (sure) {
          playerTalentSend
          .deleteTalentSend(this.deleteUuid).then((res) => {
            if (res.code) {
              this.$message.error(res.msg);
            } else {
              this.changeQuery(true);
              this.isShowDeleteTips = false;
              this.$message.success("数据已删除");
            }
          })
          .catch((err) => {
            console.error(err);
            this.isShowDeleteTips = false;
          });
        } else {
          this.isShowDeleteTips = false;
        }
      },
    }
  }
</script>

<style lang="stylus" scoped>
  @import '~@/assets/css/variable'
  .select_wrap {
    position: relative;
    .remember {
      position: absolute;
      top: 66px;
      right: 40px;
      color: #4cd964;
      font-weight: bold;
    }
    .count {
      position: absolute;
      top: 72px;
      color: #4cd964;
      font-weight: bold;
    }
  }
  .nav_wrap {
    display: flex;
    justify-content: space-between;
    font-size: 16px;

    .nav_list {
      display: flex;

      .nav_item {
        cursor: pointer;
        user-select: none;
        padding: 10px 15px;

        &.active {
          background: $green_color;
        }
      }
    }
  }
  .list_wrap
    flex 1
    overflow hidden
    .table {
      display flex
      flex-direction column
      flex 1
      width: 100%;
      // margin: 30px 0 0;
      .thead, .tbody {
        border: 1px solid $color_white;
      }
      .thead {
        margin: 0 40px;
        .tr {
          height: 45px;
          display: flex;
        }
      }
      .scrollArea {
        height: 425px;
        padding-bottom:15px
        /*flex 1 */
        /*overflow hidden*/
      }
      .tbodyWrap {
        display block
        // padding: 0 40px;
      }
      .tbody {
        display block
        width 810px
        margin-left auto
        margin-right auto
        max-width: 810px;
        border-top: none;
        border-bottom: none;
        .tr {
          height: 49px;
          display: flex;
          border-bottom: 1px solid $color_white;
        }
      }
      .th, .td {
        height: 100%;
        /*flex: 1 1 auto;*/
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: $font_size_medium;
        border-right: 1px solid $color_white;
      }
      .th:last-child, .td:last-child {
        border-right: none;
      }
      .td {
        p {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          color: $color_white;
        }
      }
      .seq{
        width 5%
      }
      .name{
        width 20%
      }
      .org{
        width: 13%;
      }
      .telNumber{
        width:25%;
      }
      .squad{
        width:10%;
      }
      .status{
        width 12%
      }
      .score{
        width 7%
      }
      .opt{
        width: 15%;
        p{
          width 100%
          text-align center
          .item{
            cursor: pointer;
            user-select: none;
            color $green_color
          }
          .split{
            margin 0 5px
          }
        }
      }
    }
  .tip
    margin-top 10px
    color red
    width 100%
    text-align center
    word-break break-word
</style>


